import { BiometricRegistrationFailedModalProvider } from '@perpay-web/fintech/hooks/useBiometricRegistrationFailedModalContext';
import { CardAddAddressModalProvider } from '@perpay-web/fintech/hooks/useCardAddAddressModalContext';
import { CardAutoPayMakePaymentModalProvider } from '@perpay-web/fintech/hooks/useCardAutoPayMakePaymentModalContext';
import { CardCancelAutoPayScheduleModalProvider } from '@perpay-web/fintech/hooks/useCardCancelAutoPayScheduleModalContext';
import { EmailMisspelledModalProvider } from '@perpay-web/fintech/hooks/useEmailMispelledModalContext';
import { NativeUpgradeNotificationModalProvider } from '@perpay-web/fintech/hooks/useNativeUpgradeNotificationModalContext';
import { PartnerOnboardingExistingUserModalProvider } from '@perpay-web/fintech/hooks/usePartnerOnboardingExistingUserModalContext';
import { PartnerOnboardingSignupIneligibleStateModalProvider } from '@perpay-web/fintech/hooks/usePartnerOnboardingSignupIneligibleStateModalContext';
import { createCombinedProvider } from '@perpay-web/utils/componentUtils';

const ModalProviders = createCombinedProvider(
    CardAutoPayMakePaymentModalProvider,
    CardAddAddressModalProvider,
    CardCancelAutoPayScheduleModalProvider,
    PartnerOnboardingSignupIneligibleStateModalProvider,
    PartnerOnboardingExistingUserModalProvider,
    EmailMisspelledModalProvider,
    NativeUpgradeNotificationModalProvider,
    BiometricRegistrationFailedModalProvider,
);

export default ModalProviders;
